import { nameof } from '@work4all/data/lib/helper/nameof';

import { Appointment } from '@work4all/models/lib/Classes/Appointment.entity';
import { Calculation } from '@work4all/models/lib/Classes/Calculation.entity';
import { CallMemo } from '@work4all/models/lib/Classes/CallMemo.entity';
import { CheckList } from '@work4all/models/lib/Classes/CheckList.entity';
import { Contract } from '@work4all/models/lib/Classes/Contract.entity';
import { DeliveryNote } from '@work4all/models/lib/Classes/DeliveryNote.entity';
import { Demand } from '@work4all/models/lib/Classes/Demand.entity';
import { Document } from '@work4all/models/lib/Classes/Document.entity';
import { EMail } from '@work4all/models/lib/Classes/EMail.entity';
import { InboundDeliveryNote } from '@work4all/models/lib/Classes/InboundDeliveryNote.entity';
import { Invoice } from '@work4all/models/lib/Classes/Invoice.entity';
import { Letter } from '@work4all/models/lib/Classes/Letter.entity';
import { Note } from '@work4all/models/lib/Classes/Note.entity';
import { Offer } from '@work4all/models/lib/Classes/Offer.entity';
import { Order } from '@work4all/models/lib/Classes/Order.entity';
import { ProductionContract } from '@work4all/models/lib/Classes/ProductionContract.entity';
import { Project } from '@work4all/models/lib/Classes/Project.entity';
import { RaViewModel } from '@work4all/models/lib/Classes/RaViewModel.entity';
import { ReViewModel } from '@work4all/models/lib/Classes/ReViewModel.entity';
import { SalesOpportunities } from '@work4all/models/lib/Classes/SalesOpportunities.entity';
import { Task } from '@work4all/models/lib/Classes/Task.entity';
import { Ticket } from '@work4all/models/lib/Classes/Ticket.entity';
import { TimeTracking } from '@work4all/models/lib/Classes/TimeTracking.entity';
import { TravelExpenses } from '@work4all/models/lib/Classes/TravelExpenses.entity';
import { TravelReceipts } from '@work4all/models/lib/Classes/TravelReceipts.entity';
import { VisitationReport } from '@work4all/models/lib/Classes/VisitationReport.entity';
import { SortDirection, SortOption } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

const taskSortOptions: SortOption[] = [
  {
    field: nameof<Task>('date'),
    direction: SortDirection.DESCENDING,
  },
];

const ticketSortOptions: SortOption[] = [
  {
    field: nameof<Ticket>('followUpDate'),
    direction: SortDirection.DESCENDING,
  },
  {
    field: nameof<Ticket>('number'),
    direction: SortDirection.DESCENDING,
  },
];

const offerSortOptions: SortOption[] = [
  {
    field: nameof<Offer>('date'),
    direction: SortDirection.DESCENDING,
  },
];

const productionContractSortOptions: SortOption[] = [
  {
    field: nameof<ProductionContract>('creationDate'),
    direction: SortDirection.DESCENDING,
  },
  {
    field: nameof<ProductionContract>('number'),
    direction: SortDirection.DESCENDING,
  },
];

const appointmentSortOptions: SortOption[] = [
  {
    field: nameof<Appointment>('startDate'),
    direction: SortDirection.DESCENDING,
  },
];

const checklistSortOptions: SortOption[] = [
  {
    field: nameof<CheckList>('date'),
    direction: SortDirection.DESCENDING,
  },
];

const noteSortOptions: SortOption[] = [
  {
    field: nameof<Note>('date'),
    direction: SortDirection.DESCENDING,
  },
];

const projectSortOptions: SortOption[] = [
  {
    field: nameof<Project>('startDateInner'),
    direction: SortDirection.DESCENDING,
  },
  {
    field: nameof<Project>('number'),
    direction: SortDirection.DESCENDING,
  },
];

const callMemoSortOptions: SortOption[] = [
  {
    field: nameof<CallMemo>('date'),
    direction: SortDirection.DESCENDING,
  },
];

const salesOpportunitiesSortOptions: SortOption[] = [
  {
    field: nameof<SalesOpportunities>('dateCreated'),
    direction: SortDirection.DESCENDING,
  },
];

const contractSortOptions: SortOption[] = [
  {
    field: nameof<Contract>('date'),
    direction: SortDirection.DESCENDING,
  },
  {
    field: nameof<Contract>('contractNumber'),
    direction: SortDirection.DESCENDING,
  },
];

const calculationSortOptions: SortOption[] = [
  {
    field: nameof<Calculation>('date'),
    direction: SortDirection.DESCENDING,
  },
  {
    field: nameof<Calculation>('number'),
    direction: SortDirection.DESCENDING,
  },
];

const deliveryNoteSortOptions: SortOption[] = [
  {
    field: nameof<DeliveryNote>('date'),
    direction: SortDirection.DESCENDING,
  },
  {
    field: nameof<DeliveryNote>('number'),
    direction: SortDirection.DESCENDING,
  },
];

const invoiceSortOptions: SortOption[] = [
  {
    field: nameof<Invoice>('date'),
    direction: SortDirection.DESCENDING,
  },
  {
    field: nameof<Invoice>('number'),
    direction: SortDirection.DESCENDING,
  },
];

const visitationReportSortOptions: SortOption[] = [
  {
    field: nameof<VisitationReport>('creationDate'),
    direction: SortDirection.DESCENDING,
  },
];

const letterSortOptions: SortOption[] = [
  {
    field: nameof<Letter>('date'),
    direction: SortDirection.DESCENDING,
  },
];

const documentSortOptions: SortOption[] = [
  {
    field: nameof<Document>('date'),
    direction: SortDirection.DESCENDING,
  },
];

const emailSortOptions: SortOption[] = [
  {
    field: nameof<EMail>('date'),
    direction: SortDirection.DESCENDING,
  },
];

const demandSortOptions: SortOption[] = [
  {
    field: nameof<Demand>('date'),
    direction: SortDirection.DESCENDING,
  },
  {
    field: nameof<Demand>('number'),
    direction: SortDirection.DESCENDING,
  },
];

const orderSortOptions: SortOption[] = [
  {
    field: nameof<Order>('date'),
    direction: SortDirection.DESCENDING,
  },
  {
    field: nameof<Order>('number'),
    direction: SortDirection.DESCENDING,
  },
];

const travelExpensesSortOptions: SortOption[] = [
  {
    field: nameof<TravelExpenses>('date'),
    direction: SortDirection.DESCENDING,
  },
];

const travelReceiptsSortOptions: SortOption[] = [
  {
    field: nameof<TravelReceipts>('date'),
    direction: SortDirection.DESCENDING,
  },
];

const reSortOptions: SortOption[] = [
  {
    field: nameof<ReViewModel>('invoiceDate'),
    direction: SortDirection.DESCENDING,
  },
  {
    field: nameof<ReViewModel>('invoiceNumber'),
    direction: SortDirection.DESCENDING,
  },
];

const raSortOptions: SortOption[] = [
  {
    field: nameof<RaViewModel>('invoiceDate'),
    direction: SortDirection.DESCENDING,
  },
];

const inboundDeliveryNoteSortOptions: SortOption[] = [
  {
    field: nameof<InboundDeliveryNote>('date'),
    direction: SortDirection.DESCENDING,
  },
  {
    field: nameof<InboundDeliveryNote>('number'),
    direction: SortDirection.DESCENDING,
  },
];

const timeTrackingSortOptions: SortOption[] = [
  {
    field: nameof<TimeTracking>('date'),
    direction: SortDirection.DESCENDING,
  },
];

export const widgetSortOptionsByEntity: Partial<
  Record<Entities, SortOption[]>
> = {
  [Entities.task]: taskSortOptions,
  [Entities.ticket]: ticketSortOptions,
  [Entities.offer]: offerSortOptions,
  [Entities.order]: orderSortOptions,
  [Entities.productionContract]: productionContractSortOptions,
  [Entities.appointment]: appointmentSortOptions,
  [Entities.checkList]: checklistSortOptions,
  [Entities.note]: noteSortOptions,
  [Entities.project]: projectSortOptions,
  [Entities.callMemo]: callMemoSortOptions,
  [Entities.salesOpportunities]: salesOpportunitiesSortOptions,
  [Entities.contract]: contractSortOptions,
  [Entities.calculation]: calculationSortOptions,
  [Entities.deliveryNote]: deliveryNoteSortOptions,
  [Entities.invoice]: invoiceSortOptions,
  [Entities.visitationReport]: visitationReportSortOptions,
  [Entities.letter]: letterSortOptions,
  [Entities.document]: documentSortOptions,
  [Entities.eMail]: emailSortOptions,
  [Entities.demand]: demandSortOptions,
  [Entities.travelExpenses]: travelExpensesSortOptions,
  [Entities.travelReceipts]: travelReceiptsSortOptions,
  [Entities.reViewModel]: reSortOptions,
  [Entities.raViewModel]: raSortOptions,
  [Entities.inboundDeliveryNote]: inboundDeliveryNoteSortOptions,
  [Entities.timeTracking]: timeTrackingSortOptions,
};
